<template>
  <pagelayout :contentBgcolor="isDark && '#eeeeee'">
    <appbar :title="`双色球${app_my_config.lotteryCredit.name}说明`" />
    <div class="guide">
      <div class="tit">不出号码</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">不出号码</td>
            <td>
              选择当期开奖中您认为不会出现的号码，即为不出号码（定胆杀号）。
              <br />
              投注方案：红球不出<span style="color:red">12</span>，蓝球不出<span style="color:blue">06</span>。开奖号码：<span
                style="color:red">02</span> <span style="color:red">06</span> <span style="color:red">10</span> <span
                style="color:red">22</span> <span style="color:red">25</span> <span style="color:red">30</span> <span
                style="color:blue">11</span>，即为中奖。
            </td>
          </tr>
        </tbody>
      </table>
      <div class="tit">必出号码</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">必出号码</td>
            <td>
              选择当期开奖中您认为必定出现的数字，即为必出号码。
              <br />
              投注方案：红球必出<span style="color:red">02</span>，蓝球必出<span style="color:blue">11</span>。开奖号码：<span
                style="color:red">02</span> <span style="color:red">06</span> <span style="color:red">10</span> <span
                style="color:red">22</span> <span style="color:red">25</span> <span style="color:red">30</span> <span
                style="color:blue">11</span>，即为中奖。
            </td>
          </tr>
        </tbody>
      </table>
      <div class="tit">两面</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">第一球(两面)</td>
            <td>
              当开奖结果的第1个红球号码是奇数，为单；是偶数，为双。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">第二球(两面)</td>
            <td>
              当开奖结果的第2个红球号码是奇数，为单；是偶数，为双。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">第三球(两面)</td>
            <td>
              当开奖结果的第3个红球号码是奇数，为单；是偶数，为双。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">第四球(两面)</td>
            <td>
              当开奖结果的第4个红球号码是奇数，为单；是偶数，为双。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">第五球(两面)</td>
            <td>
              当开奖结果的第5个红球号码是奇数，为单；是偶数，为双。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">第六球(两面)</td>
            <td>
              当开奖结果的第6个红球号码是奇数，为单；是偶数，为双。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">第七球(两面)</td>
            <td>
              当开奖结果的第7个蓝球号码是奇数，为单；是偶数，为双。
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </pagelayout>
</template>

<script>
import appConfigMixins from "@c/mixins/appConfig.mixins";
export default {
  mixins: [appConfigMixins],
};
</script>

<style lang="scss">@import "~/assets/common/page/guide.scss";</style>
